import React from "react";
import './sizeblock.css';
import { useSelector } from "react-redux";

const QualityBlock = ({quality,pagename,disabled}) => {

    return (
        // <div>
            <div className={`${pagename === "homepage"? "homepage-sizepill"  : "sizepill " } ${disabled? "sizepill-disabled" : ""}`}>
                {quality}
            </div>
        // </div>
    )
};

export default QualityBlock;